import { useClientContext } from "@hooks/index";
import { applyStatusToleranceToEvents } from "@module/utils/statusTolerance";
import { useQuery } from "@tanstack/react-query";
import { getStatusByDate } from "./index";

export const useGetStatusByDate = (date: Date) => {
  const customFetch = useClientContext();

  return useQuery({
    retry: false,
    queryKey: ["timeline", date],
    queryFn: () => getStatusByDate(customFetch)(date),
    enabled: Boolean(date),
    select: applyStatusToleranceToEvents,
  });
};
